export default {
  left_column: {
    title: 'Consultar saldo',
    description:
      'Introduce el código de tu tarjeta regalo para consultar el saldo restante. El código se encuentra en el PDF de tu tarjeta regalo.',
  },
  title: 'Consultar saldo de tarjeta regalo',
  subtitle: 'Introduce un código de tarjeta regalo para consultar su saldo actual',
  error: {
    title: '¡Tarjeta regalo no encontrada!',
    description: 'Por favor, introduce un código de tarjeta regalo válido.',
  },
  gift_card: {
    title: '¡Tarjeta regalo encontrada!',
    balance: 'Saldo',
    value: 'Valor',
    expires_at: 'Caduca el',
  },
  form: {
    code: {
      label: 'Código de tarjeta regalo',
    },
  },
  buttons: {
    check_balance: 'Consultar saldo',
  },
};
